module.exports = __webpack_public_path__ + "img/4.6f6b08f0.png";